import React from "react";
import Image from "next/image";

interface ThreeBlockProps {
  bgColor: string;
  miniTitle: string;
  title: string;
  subtitle: string;
  ctaText: string;
  ctaURL: string;
  blocks: Array<{
    miniTitle: string;
    title: string;
    content: string;
    imageUrl: string;
    altText: string;
    pdfUrl: string;
    iconUrl: string;
    ctaText: string;
  }>;
  titleTag: React.ElementType;
  miniTitleTag: React.ElementType;
}

const ThreeBlocks: React.FC<ThreeBlockProps> = ({
  bgColor,
  miniTitle,
  title,
  subtitle,
  ctaText,
  ctaURL,
  blocks,
  titleTag = "h2",
  miniTitleTag = "h3"
}) => {
  const TitleTag = titleTag;
  const MiniTitleTag = miniTitleTag;

  return (
    <section
      id="threeblocks-42"
      className="@container"
      style={{
        backgroundColor: bgColor
      }}
    >
      <div className="tile-container !py-24">
        <div className="tile-title-container">
          {miniTitle && <MiniTitleTag className="subby text-center">{miniTitle}</MiniTitleTag>}
          {title && <TitleTag className="tile-main-header [text-wrap:balance]">{title}</TitleTag>}
          {subtitle && <p className="mt-4 text-xl text-primary-700">{subtitle}</p>}

          {ctaText && ctaURL ? (
            <a className="tile-btn mt-8 px-8 py-3" href={ctaURL} title={ctaText}>
              {ctaText}
            </a>
          ) : null}
        </div>

        <div className="grid grid-cols-1 gap-6 @3xl:grid-cols-2 @7xl:grid-cols-3">
          {blocks.map((block, index) => (
            <div key={index} className="flex flex-col rounded-xl bg-[#F2F0E6]">
              {!!block.imageUrl && (
                <Image
                  className="w-full rounded-t-lg object-contain"
                  src={block.imageUrl}
                  alt={block.altText}
                  width={400}
                  height={256}
                />
              )}
              <div className="flex h-full flex-col items-start justify-between p-8">
                <div className="w-full">
                  {!!block.miniTitle && (
                    <p className="mb-3 text-2xs font-semibold uppercase text-primary-700">{block.miniTitle}</p>
                  )}
                  <div className="flex items-start justify-between">
                    <h3 className="font-heading text-3xl text-primary-700">{block.title}</h3>
                    {!!block.iconUrl && (
                      <Image className="ml-2 w-9" src={block.iconUrl} width={36} height={36} alt="Floating image" />
                    )}
                  </div>
                  {!!block.content && <p className="mt-3 text-sm text-primary-700">{block.content}</p>}
                </div>
                {!!block.pdfUrl && (
                  <a
                    href={block.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 block w-auto rounded-full bg-brand px-6 py-2 text-center text-sm font-medium text-white shadow-sm hover:bg-[#0A1A1F] @5xl:inline-block"
                  >
                    {block.ctaText || "Download"}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreeBlocks;
